import { render } from "./ServiceLocations.vue?vue&type=template&id=ba91dcb6"
import script from "./ServiceLocations.ts?vue&type=script&lang=js&external"
export * from "./ServiceLocations.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__